import React, { useMemo } from 'react';
import { TInheritedProps } from '@ts/storybook';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn, generateDateColumn, generateEntityColumn } from '@ts/storybook';
import { CChannel, CChannelType } from '@ts/ui-models';

interface IChannelsProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'channels',
  aclId: 'Channel',
  entity: 'channel',
  fetchURL: '/api/channels',
  crudURL: '/api/channel',
  mainClass: CChannel,
};

const Channels = (props: IChannelsProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateEntityColumn(
        { field: 'channelType', headerName: 'Channel type' },
        { field: 'channelType', mainClass: CChannelType },
        { inheritedProps }
      ),
      generateBasicColumn({ field: 'bound', headerName: 'Purpose' }, { field: 'bound' }),
      generateDateColumn({ field: 'createdAt', headerName: 'Created', isSortable: true }, { field: 'createdAt' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default Channels;
